import { Stack } from "@mantine/core";
import { OptiSupportEndpoints } from "../../../../../urls";
import { LoadOrError } from "../../../../LoadOrError/LoadOrError";
import { OptiSupportHelpLink } from "../../../../OptiSupportHelpLink/OptiSupportHelpLink";
import { useFictionalEnergyValues } from "../../hooks/useFictionalEnergyValues";
import { FictionalEnergyValuesTable } from "../FictionalEnergyValuesTable/FictionalEnergyValuesTable";

export interface FictionalEnergyValueResponse {
  id: string;
  created: string;
  generator: number | null;
  generatorDisplayName: string | null;
  firstDate: string | null;
  lastDate: string | null;
  technischeNichtverfuegbarkeitKwh: number | null;
  redispatchAbregelungKwh: number | null;
  sonstigeAbschaltungOderDrosselungKwh: number | null;
}

interface FictionalEnergyValueManagerProps {
  variantId: number;
}

function FictionalEnergyValueManager({
  variantId
}: FictionalEnergyValueManagerProps) {
  const { fictionalEnergyValues, error, isLoading } =
    useFictionalEnergyValues(variantId);

  return (
    <div className="FictionalEnergyValueManager">
      <LoadOrError
        error={error}
        loading={isLoading}
        loadingMessage="Fiktive Strommengen werden geladen ..."
      >
        <Stack gap="xs">
          <OptiSupportHelpLink
            optiSupportEndpoint={
              OptiSupportEndpoints.BeruecksichtigungFiktiveMengen
            }
            text="Wie berücksichtigt opti.node die fiktiven Mengen?"
          />
          <FictionalEnergyValuesTable
            fictionalEnergyValues={fictionalEnergyValues || []}
            variantId={variantId}
          />
        </Stack>
      </LoadOrError>
    </div>
  );
}

export { FictionalEnergyValueManager, FictionalEnergyValueManagerProps };
